export const capitalize = (str) => {
    if (!str)
        return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
export const pluralize = (count, one, few, many) => {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod100 >= 11 && mod100 <= 19)
        return many;
    if (mod10 === 1)
        return one;
    if (mod10 >= 2 && mod10 <= 4)
        return few;
    return many;
};
//# sourceMappingURL=string.js.map